"use client";

import NotFoundResult from "@/components/NotFoundResult";
import { Button } from "antd-mobile";
import { useRouter } from "next/navigation";
import React from "react";

const NotFound: React.FC = () => {
  const router = useRouter();

  return (
    <NotFoundResult
      extra={[
        <Button
          key="again"
          color="primary"
          fill="solid"
          style={{ fontSize: "1.25rem", fontWeight: 500 }}
          onClick={() => router.push("/")}
        >
          Return Home
        </Button>,
      ]}
    />
  );
};

export default NotFound;
